import React from "react";
import Dropzone from "react-dropzone";
import { Button, Icon } from "antd";

const thumbsContainer = {
	display: "flex",
	flexDirection: "row",
	flexWrap: "wrap",
	marginTop: 16
};

const thumb = {
	display: "inline-flex",
	borderRadius: 2,
	border: "1px solid #eaeaea",
	marginBottom: 8,
	marginRight: 8,
	width: 100,
	height: 100,
	padding: 4,
	boxSizing: "border-box"
};

const thumbInner = {
	display: "flex",
	minWidth: 0,
	overflow: "hidden"
};

const img = {
	display: "block",
	width: "auto",
	height: "100%"
};

class ImageSet extends React.Component {
	onDrop = acceptedFiles => {
		const f = acceptedFiles.map(file =>
			Object.assign(file, {
				preview: URL.createObjectURL(file)
			})
		);
		this.props.form.setFieldValue(this.props.name, f);
	};

	render() {
		return (
			<div>
				<Dropzone
					onDrop={this.onDrop}
					disabledStyle={{ backgroundColor: "gray" }}
					style={{
						borderStyle: "solid",
						backgroundColor: "white"
					}}>
					{({ getRootProps, getInputProps }) => (
						<React.Fragment>
							<div {...getRootProps()}>
								<input {...getInputProps()} />
								<Button>
									<Icon type="upload" /> Sube fotos o videos
								</Button>
							</div>
							<aside style={thumbsContainer}>
								{this.props.value &&
									this.props.value.map((file, i) => {
										return (
											<React.Fragment>
												{file.type === "image/png" ||
													file.type === "image/jpg" ||
													(file.type === "image/jpeg" && (
														<div style={thumb} key={i}>
															<div style={thumbInner}>
																<img src={file.preview || file.imageSetLink} style={img} />
															</div>
														</div>
													))}
											</React.Fragment>
										);
									})}
							</aside>
						</React.Fragment>
					)}
				</Dropzone>
			</div>
		);
	}
}

export default ImageSet;
